import { useState, createContext, useEffect } from "react";
import PropTypes from "prop-types";

export const ThemeContext = createContext();

export function ThemeContextProvider({ children }) {
    
    const getInitialTheme = () => {
        try {
            return localStorage.getItem("theme") || "theme-khc";
        } catch (error) {
            console.error("LocalStorage erişim hatası:", error);
            return "theme-khc";
        }
    };

    const [theme, setTheme] = useState(() => getInitialTheme());

    useEffect(() => {
        try {
            localStorage.setItem("theme", theme);
        } catch (error) {
            console.error("LocalStorage yazma hatası:", error);
        }
    }, [theme]);

    const toggleTheme = (themeValue) => {
        setTheme(themeValue);
    };

    return (
        <ThemeContext.Provider value={{ theme, toggleTheme }}>
            {children}
        </ThemeContext.Provider>
    );
}

ThemeContextProvider.propTypes = {
    children: PropTypes.node,
};
